import { IBidsRankData } from '../types';

export function formatBidRankResponse(
  bidRankData: IBidsRankData
): IBidsRankData {
  const {
    bidNotWinning,
    hotDeal,
    inQueue,
    noBids,
    outOfQuantity,
    rankOne,
    runnerUp,
    totalAssetCount,
    totalBids,
    winningRange,
  } = bidRankData || {};

  return {
    bidNotWinning,
    hotDeal,
    inQueue,
    myBids: totalBids,
    noBids,
    outOfQuantity,
    rankOne,
    runnerUp,
    totalAssetCount,
    totalBids,
    winningRange,
  };
}
